import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-screen bg-gray-100 justify-center items-center" }
const _hoisted_2 = { class: "flex-initial bg-white p-3 rounded shadow" }
const _hoisted_3 = { method: "post" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createVNode(_component_ElButton, {
          type: "danger",
          size: "medium",
          "native-type": "submit",
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Войти")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}